import { useEffect } from 'react';

import { Button } from '../components/Button.js';
import type { Bounce } from '../data/moderation.js';
import { track } from '../lib/analytics.js';
import { cidParts } from '../lib/bridge.js';
import styles from './BouncedNotice.module.css';

export type BannerSurface = 'chat' | 'widget' | 'pane';

export interface BouncedActions {
  surface: BannerSurface;
  dismiss: () => void;
}

/** The card where a message Stream moderation bounced would have been; only its sender sees it. */
export function BouncedNotice({ channelId, messageId, surface, dismiss }: Bounce & BouncedActions) {
  const props = {
    banner_type: 'inappropriate',
    channel_id: cidParts(channelId).channelId,
    message_id: messageId,
    surface,
  };

  useEffect(() => {
    // Keyed on the bounce alone: once per open of the chat, not per re-render.
    track('moderation_banner_shown', props);
  }, [messageId]);

  const understood = () => {
    track('moderation_banner_clicked', { ...props, action: 'understood' });
    dismiss();
  };

  return (
    <section className={styles.card} aria-labelledby={`bounced-${messageId}`}>
      <h3 id={`bounced-${messageId}`} className={styles.title}>
        Keep conversations respectful
      </h3>
      <p className={styles.body}>
        Your recent message was not sent because it contains inappropriate content.
        <br />
        Please keep your messages polite and professional.
      </p>
      <Button onClick={understood}>I Understand</Button>
    </section>
  );
}
